import React from 'react';
import PropTypes from 'prop-types';
import Container from 'react-bootstrap/Container';
import Header from 'components/Header';
import Footer from 'components/Footer';

const PublicLayout = ({ children }) => {
    return (
        <div className="public">
            <Container fluid className="p-0">
                <Header />
            </Container>
            <Container className="container__app">
                {children}
            </Container>
            <Container fluid className="p-0">
                <Footer />
            </Container>
        </div>);
};

PublicLayout.propTypes = {
    children: PropTypes.any,
};

export default PublicLayout;
